// extracted by mini-css-extract-plugin
export default {"card":"MaterialDeleteModal_card__tRHCU","footer":"MaterialDeleteModal_footer__ZH08E","button":"MaterialDeleteModal_button__OKxIG","heading":"MaterialDeleteModal_heading__eeFbj"};